'use client';
import { createContext } from '@chakra-ui/utils';
import { createDescendantContext } from '../descendant/use-descendant.mjs';

const [
  TabsDescendantsProvider,
  useTabsDescendantsContext,
  useTabsDescendants,
  useTabsDescendant
] = createDescendantContext();
const [TabsContextProvider, useTabsContext] = createContext({
  name: "TabsContext",
  errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
const [TabContentProvider, useTabContentContext] = createContext({});
const [TabsStylesProvider, useTabsStyles] = createContext({
  name: `TabsStylesContext`,
  errorMessage: `useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tabs />" `
});

export { TabContentProvider, TabsContextProvider, TabsDescendantsProvider, TabsStylesProvider, useTabContentContext, useTabsContext, useTabsDescendant, useTabsDescendants, useTabsDescendantsContext, useTabsStyles };
